import type { Detection } from '../types/api';
import { getEntityLabel } from '../utils/labels';

interface Props {
  detections: Detection[];
  selectedIndices: Set<number>;
  onToggle: (index: number, selected: boolean) => void;
}

export function DetectionList({ detections, selectedIndices, onToggle }: Props) {
  if (detections.length === 0) return null;
  return (
    <div className="detection-list">
      {detections.map((d, i) => {
        const isSelected = selectedIndices.has(i);
        return (
          <div
            key={`${d.type}-${d.start}-${i}`}
            className={`detection-row${!isSelected ? ' struck' : ''}`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onToggle(i, e.target.checked)}
              className="detection-checkbox"
            />
            <span className={`badge type-${d.type}`}>{getEntityLabel(d.type)}</span>
            <span className="text">{d.text}</span>
            <span className="score">{Math.round(d.score * 100)}%</span>
          </div>
        );
      })}
    </div>
  );
}
